const MyDay = ({ size = 24, color = "var(--primary-text-color)", variant = 1 }) => {
    if (variant === 1) {
        // Sunrise over horizon — half sun with rays rising above a line
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height={`${size}px`}
                width={`${size}px`}
                viewBox="0 0 24 24"
                fill="none"
            >
                {/* Horizon line */}
                <path d="M3 17h18" stroke={color} strokeWidth="2" strokeLinecap="round" />
                {/* Half sun */}
                <path d="M12 17a5 5 0 0 1-5-5h10a5 5 0 0 1-5 5z" fill={color} />
                {/* Sun rays */}
                <path d="M12 5v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
                <path d="M5.64 8.64l1.41 1.41" stroke={color} strokeWidth="2" strokeLinecap="round" />
                <path d="M18.36 8.64l-1.41 1.41" stroke={color} strokeWidth="2" strokeLinecap="round" />
                {/* Bottom task lines */}
                <path d="M6 20h12" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5" />
            </svg>
        );
    }

    if (variant === 2) {
        // Card stack with a spark/diamond accent
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height={`${size}px`}
                width={`${size}px`}
                viewBox="0 0 24 24"
                fill="none"
            >
                {/* Back card */}
                <rect x="5" y="4" width="14" height="16" rx="2" stroke={color} strokeWidth="1.5" opacity="0.3" />
                {/* Front card */}
                <rect x="3" y="6" width="14" height="14" rx="2" fill={color} opacity="0.15" stroke={color} strokeWidth="1.5" />
                {/* Checklist lines on front card */}
                <path d="M6 11h7" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 14.5h5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
                {/* Spark / 4-point star accent */}
                <path d="M19 3l.9 2.1L22 6l-2.1.9L19 9l-.9-2.1L16 6l2.1-.9L19 3z" fill={color} />
            </svg>
        );
    }

    if (variant === 3) {
        // Circular target/focus with a checkmark
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height={`${size}px`}
                width={`${size}px`}
                viewBox="0 0 24 24"
                fill="none"
            >
                {/* Outer ring */}
                <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" opacity="0.3" />
                {/* Inner ring */}
                <circle cx="12" cy="12" r="5.5" stroke={color} strokeWidth="1.5" />
                {/* Center dot */}
                <circle cx="12" cy="12" r="2" fill={color} />
            </svg>
        );
    }

    // Default: variant 2 (card + spark)
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 0 24 24"
            fill="none"
        >
            <rect x="3" y="6" width="14" height="14" rx="2" fill={color} opacity="0.15" stroke={color} strokeWidth="1.5" />
            <path d="M6 11h7" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M6 14.5h5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M19 3l.9 2.1L22 6l-2.1.9L19 9l-.9-2.1L16 6l2.1-.9L19 3z" fill={color} />
        </svg>
    );
}

export default MyDay;
